<mat-label>
  <h2 class="center" mat-dialog-title>Nueva Solicitud ({{posgrado?'Maestría':'Licenciatura'}})</h2>
</mat-label>
<div mat-dialog-content>
  @if (index < 0) {
    <p>
      El Instituto Tecnólogico de Tehuacán te da la más Cordial Bienvenida.
    </p>
    <p>
      Antes de Comenzar a Llenar la Solicitud, te Recomendamos que Leas Cuidadosamente los
      Siguientes Requisitos, te Ayudarán en el Proceso de Registro de la Solicitud. Es Importante Detenerse
    a Leer estas Recomendaciones antes de Continuar.</p>
    <p>
      Para Contar con éste Registro Debes Pulsar en el Boton de Continuar, y Capturar los Datos Iniciales
      como son el Apellido Paterno, Materno, Nombre(s), CURP, Correo y Número de Télefono del Aspirante.
      El Sistema te Indicara tu Número de Solicitud y una Contraseña Generada; te Recomendamos que los Anotes
      y los Tengas a la Mano, con ellos Podrás Ingresar.
    </p>
    <p>Cuando ya Termines, Presiona Aceptar, con ello Podrás Entrar al Sistema y Comenzar
      como Aspirante ya Registrado, y Capturar la Solicitud Completamente e
      Imprimir la Solicitud. Te Sugerimos te Pongas Cómodo y Dispuesto a Capturar esta
      Solicitud, el Tiempo Estimado de Captura Será de Aproximadamente 30 Minutos.
    </p>
  } @else {
    <mat-stepper [selectedIndex]="index" linear #stepper>
      <mat-step [stepControl]="formSol" [editable]="false">
        <form [formGroup]="formSol">
          <ng-template matStepLabel>Registra tu Información</ng-template>
          <div class="row justify-content-center align-self-center">
            <div class="col-12 col-sm-6 col-lg-4">
              <mat-form-field>
                <mat-label>Nombre</mat-label>
                <input matInput type="text" placeholder="Nombre o Nombres del Aspirante"
                  formControlName="nombreAspirante">
              </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-lg-4">
              <mat-form-field>
                <mat-label>Apellido Paterno</mat-label>
                <input matInput type="text" placeholder="Apellido Paterno del Aspirante"
                  formControlName="apellidoPaternoAspirante">
              </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-lg-4">
              <mat-form-field>
                <mat-label>Apellido Materno</mat-label>
                <input matInput type="text" placeholder="Apellido Materno del Aspirante"
                  formControlName="apellidoMaternoAspirante">
              </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-lg-4">
              <mat-form-field>
                <mat-label>CURP</mat-label>
                <input matInput type="text" placeholder="CURP del Aspirante"
                  formControlName="CURPAspirante">
              </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-lg-5">
              <mat-form-field>
                <mat-label>Correo:</mat-label>
                <input class="correo" placeholder="Correo Electrónico del Aspirante" matInput
                  formControlName="correoAspiranteUsuario">
                <mat-select class="correo" formControlName="correoAspiranteDominio">
                  <mat-option value="">&#64;</mat-option>
                  <mat-option value="outlook.com">&#64;OUTLOOK.COM</mat-option>
                  <mat-option value="hotmail.com">&#64;HOTMAIL.COM</mat-option>
                  <mat-option value="gmail.com">&#64;GMAIL.COM</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
              <mat-form-field>
                <mat-label>Teléfono</mat-label>
                <input matInput type="text" placeholder="Teléfono del Aspirante"
                  formControlName="telefonoAspirante">
              </mat-form-field>
            </div>
            <div class="col-12">
              <re-captcha [theme]="darkMode?'dark':'light'" #captcha [siteKey]="siteKey"
              (resolved)="resolved($event)" errorMode="handled"></re-captcha>
            </div>
          </div>
        </form>
      </mat-step>
      <mat-step sele>
        <ng-template matStepLabel>Registro Completo</ng-template>
        <p class="text-center">
          Con los siguientes datos podrás entrar al sistema y comenzar
          como aspirante ya registrado, debderas capturar la solicitud completamente e
          imprimirla.
        </p>
        <div class="row gx-1">
          <div class="col-6 text-end">
            <p><strong>No Solicitud:</strong></p>
          </div>
          <div class="col-6 text-start">
            <span>{{no_solicitud}}</span>
          </div>
          <div class="col-6 text-end">
            <p><strong>Contraseña:</strong></p>
          </div>
          <div class="col-6 text-start">
            <span>{{password}}</span>
          </div>
        </div>
        <p class="text-center">
          Te Sugerimos te Pongas Cómodo y Dispuesto a Capturar Toda la
          Solicitud, el Tiempo Estimado de Captura es de Aproximadamente 30 Minutos.
        </p>
      </mat-step>
    </mat-stepper>
  }

</div>
<mat-dialog-actions class="row">
  <div class="col-12 col-sm-6 gy-2 gy-sm-0 text-center text-sm-end">
    <button mat-raised-button [disabled]="index > 0" (click)="onNoClick()">
      <span>Cancelar</span>
    </button>
  </div>
  <div class="col-12 col-sm-6 gy-2 gy-sm-0 text-center text-sm-start">

    <div>
      @switch (index) {
        @case (-1) {
          <div>
            <button mat-raised-button (click)="continuar()" color="primary" cdkFocusInitial>
              <span>Continuar</span>
            </button>
          </div>
        }
        @case (0) {
          <div>
            <button mat-raised-button (click)="guardar()" [disabled]="!formSol.valid" color="primary"
              cdkFocusInitial>
              <span>Registrarme</span>
            </button>
          </div>
        }
        @default {
          <div>
            <button mat-raised-button (click)="aceptar()" color="primary" cdkFocusInitial>
              <span>Aceptar</span>
            </button>
          </div>
        }
      }
    </div>

  </div>
</mat-dialog-actions>
